import './VideoCaptions.css';

export default function VideoCaptions({ 
  captions = [],
  currentTime = 0,
  className = ''
}) {
  const activeCaption = captions.find(caption => 
    currentTime >= caption.startTime && 
    currentTime <= caption.endTime
  );

  if (!activeCaption) return null;

  return (
    <div className={`zibby-video-captions ${className}`}>
      <div className="zibby-caption-text">
        {activeCaption.text}
      </div>
    </div>
  );
}

